import type { BadgeTone } from '@bennows/boows-react';
import type { BillingState } from './useTenants';

/** Badge tone per billing state, shared by the list and the detail. */
export const BILLING_TONES: Record<BillingState, BadgeTone> = { metered: 'success', exempt: 'info', none: 'neutral', unlinked: 'neutral', unknown: 'warning' };
